import React from 'react'
import Hero from '../Hero';
import StudentImage from "../../assets/images/hero/student.jpg"
import About from './About';
import Timeline from '../MSAProgramme/Timeline/Timeline'

function MSAProgramme() {
    return(
        <div>
            <Hero title="MSA Programme" heroImage={StudentImage} />
            <About/>
            {/* <CurrentPhase/> */}
            <Timeline/>
        </div>
    )
}

export default MSAProgramme;
